import * as z$1 from "zod/v4";
//#region src/schemas/local-machine/macos-keychain-helper.ts
const MAC_OS_KEYCHAIN_HELPER_SCHEMA_VERSION = 2;
const MAC_OS_KEYCHAIN_AUTHENTICATION_INTERACTION = "disallow";
const macOsKeychainServiceSchema = z$1.string().trim().min(1).max(512);
const macOsKeychainAccountSchema = z$1.string().trim().min(1).max(512);
const macOsKeychainAccessTokenSchema = z$1.string().min(1).max(65536);
const macOsKeychainHelperOperationSchema = z$1.enum([
	"store",
	"read",
	"delete"
]);
const macOsKeychainHelperRequestSchema = z$1.discriminatedUnion("operation", [
	z$1.strictObject({
		schemaVersion: z$1.literal(2),
		operation: z$1.literal("store"),
		service: macOsKeychainServiceSchema,
		account: macOsKeychainAccountSchema,
		accessToken: macOsKeychainAccessTokenSchema,
		authenticationInteraction: z$1.literal(MAC_OS_KEYCHAIN_AUTHENTICATION_INTERACTION)
	}),
	z$1.strictObject({
		schemaVersion: z$1.literal(2),
		operation: z$1.literal("read"),
		service: macOsKeychainServiceSchema,
		account: macOsKeychainAccountSchema,
		authenticationInteraction: z$1.literal(MAC_OS_KEYCHAIN_AUTHENTICATION_INTERACTION)
	}),
	z$1.strictObject({
		schemaVersion: z$1.literal(2),
		operation: z$1.literal("delete"),
		service: macOsKeychainServiceSchema,
		account: macOsKeychainAccountSchema,
		authenticationInteraction: z$1.literal(MAC_OS_KEYCHAIN_AUTHENTICATION_INTERACTION)
	})
]);
const macOsKeychainHelperMutationSuccessSchema = z$1.strictObject({
	schemaVersion: z$1.literal(2),
	ok: z$1.literal(true),
	operation: z$1.enum(["store", "delete"])
});
const macOsKeychainHelperReadSuccessSchema = z$1.strictObject({
	schemaVersion: z$1.literal(2),
	ok: z$1.literal(true),
	operation: z$1.literal("read"),
	accessToken: z$1.union([macOsKeychainAccessTokenSchema, z$1.null()])
});
const macOsKeychainHelperErrorSchema = z$1.strictObject({
	schemaVersion: z$1.literal(2),
	ok: z$1.literal(false),
	operation: macOsKeychainHelperOperationSchema,
	errorMessage: z$1.string().trim().min(1).max(2048)
});
const macOsKeychainHelperResponseSchema = z$1.union([
	macOsKeychainHelperMutationSuccessSchema,
	macOsKeychainHelperReadSuccessSchema,
	macOsKeychainHelperErrorSchema
]);
//#endregion
export { MAC_OS_KEYCHAIN_AUTHENTICATION_INTERACTION, MAC_OS_KEYCHAIN_HELPER_SCHEMA_VERSION, macOsKeychainHelperOperationSchema, macOsKeychainHelperRequestSchema, macOsKeychainHelperResponseSchema };

//# sourceMappingURL=macos-keychain-helper.js.map